(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cf-quantity-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-quantity-offer')) {
  customElements.define('cf-quantity-offer', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info');
      this.controller = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-cf-variants]').textContent);
      this.protected = false;
      this.refresh = () => {
        const quantity = this.scope?.querySelector('input.quantity__input[name="quantity"]');
        const count = Math.max(1, Number(quantity?.value) || 1);
        const tier = Math.min(3, count);
        const id = this.scope?.querySelector('product-form input[name="id"]')?.value;
        const variant = this.variants.find(v => String(v.id) === id) || this.variants[0];
        const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency}).format(cents / 100);
        this.querySelectorAll('.cf-offer-card').forEach(card => {
          const n = Number(card.dataset.tier);
          card.querySelector('input[type="radio"]').checked = n === tier;
          const check = card.querySelector('[data-cf-protection]');
          if (check) { check.disabled = n !== tier; check.checked = n === tier && this.protected; }
          const units = n === 3 ? Math.max(3,count) : n;
          const base = variant.price * units;
          const total = card.querySelector('[data-offer-total]');
          const totalText = format(Math.round(base * (n === 3 ? 0.6 : n === 2 ? 0.8 : 1)));
          if (total.textContent !== totalText) total.textContent = totalText;
          const original = card.querySelector('[data-offer-original]');
          if (original && original.textContent !== format(base)) original.textContent = format(base);
        });
      };
      this.addEventListener('change', event => {
        if (event.target.matches('[data-cf-protection]')) { this.protected = event.target.checked; this.refresh(); return; }
        if (event.target.type !== 'radio') return;
        const quantity = this.scope?.querySelector('input.quantity__input[name="quantity"]');
        if (!quantity) return;
        quantity.value = event.target.value;
        quantity.dispatchEvent(new Event('change', {bubbles:true}));
      }, {signal:this.controller.signal});
      this.scope?.addEventListener('change', this.refresh, {signal:this.controller.signal});
      this.observer = new MutationObserver(this.refresh);
      if (this.scope) this.observer.observe(this.scope, {childList:true,subtree:true,attributes:true,attributeFilter:['value']});
      this.refresh();
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
